import { FaTripadvisor, FaGoogle, FaInstagram } from "react-icons/fa";
import { Gift, UtensilsCrossed } from "lucide-react";
import type { CtaType, LinkTreeCta } from "@/data/linkTreeVenues";
import { cn } from "@/lib/utils";

interface LinkTreeCtaButtonProps {
  cta: LinkTreeCta;
  onClick: (cta: LinkTreeCta) => void;
}

const CTA_ICONS: Record<CtaType, React.ReactNode> = {
  menu: <UtensilsCrossed className="h-5 w-5" />,
  tripadvisor: <FaTripadvisor className="h-5 w-5" />,
  google: <FaGoogle className="h-5 w-5" />,
  instagram: <FaInstagram className="h-5 w-5" />,
  bestiebite: <Gift className="h-5 w-5" />,
};

export default function LinkTreeCtaButton({ cta, onClick }: LinkTreeCtaButtonProps) {
  const isMock = cta.isMock === true;
  const isMenu = cta.type === "menu";

  return (
    <button
      type="button"
      onClick={() => !isMock && onClick(cta)}
      disabled={isMock}
      className={cn(
        "flex w-full items-center justify-center gap-3 rounded-2xl px-6 py-5 transition-all duration-200",
        isMock
          ? "cursor-not-allowed bg-stone-300 text-stone-500 shadow-sm"
          : isMenu
          ? "border border-stone-900 bg-white text-stone-800 shadow-[0_2px_12px_rgba(0,0,0,0.06)] hover:bg-stone-50 hover:shadow-[0_4px_16px_rgba(0,0,0,0.1)] active:scale-[0.98]"
          : "bg-link-tree-accent text-white shadow-[0_2px_12px_rgba(212,76,53,0.3)] hover:shadow-[0_4px_20px_rgba(212,76,53,0.4)] active:scale-[0.98]",
      )}
    >
      <span className="flex-shrink-0">{CTA_ICONS[cta.type]}</span>
      <span className="flex flex-col items-center">
        <span className="text-[15px] font-semibold tracking-wide">{cta.label}</span>
        {isMock && (
          <span className="text-[11px] font-normal text-stone-400">In arrivo</span>
        )}
      </span>
    </button>
  );
}
